import {
  Select,
  Layout,
  Table,
  message,
  Button,
  Upload,
  Spin,
  Image,
  DatePicker,
} from "antd";
import React, { useState, useEffect } from "react";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import { useHistory,Link } from "react-router-dom";
import PRReportAbbott from "../PRReports/PRReportAbbott";
import PRReportIntegra from "../PRReports/PRReportIntegra";
import PRHPE from "../PRReports/PRReportHPE";
import PRReportBMS from "../PRReports/PRReportBMS";
import PRReports from "../PRReports/PRReportAmgen";
import { downloadMultipleBMSmasterFileXL } from "../../Repository/PRReportsRepository";
import axios from "axios";
import moment from "moment";
import Cookies from "js-cookie";
// import "../PRReports/PRReports.css";
import "../../GlobalCss/SPF/PRReports.css";
import {
  DownloadOutlined,
  DeleteOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import {
  FormConfig,
  JsonConfig,
  StringConfig,
  UserName,
} from "../../Repository/BaseRepository";
import PRReportSales from "./PRReportSales";
import PRReportTotalEnergies from "./PRReportTotalEnergies";
import {
  downloadUnmatchedXL,
  downloadBMSUnmatchedXL,
  downloadAbbottUnmatchedXL,
  downloadIntegraUnmatchedXL,
  downloadHpeUnmatchedXL,
  downloadLeoforceUnmatchedXL,
  downloadAllUnmatchedXL,
} from "../../Repository/PRReportsRepository";
import * as XLSX from "xlsx";

const { Header, Content } = Layout;

const PRReportsHomePage = () => {
  const [selectedClient, setSelectedClient] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [loadingT, setLoadingTable] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const [loader, setLoader] = useState(false);

  const [selectedMultiClients, setSelectedMultiClients] = useState([]);
  const history = useHistory();
  const [selectedClients, setSelectedClients] = useState([]);
  const [uploading, setUploading] = useState(false);
  const allowedClients = ["Abbott", "HPE", "Integra"];
  const BaseUrl = process.env.REACT_APP_BASE_URL;
  // Temp array to accumulate files
  const tempFiles = [];

  const [prreport, setPrreport] = useState([]);
  const [prUploader, setPrUploader] = useState("");
  const [activespin, setActivespin] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [Fromdate, setfromDate] = useState(null);
  const [ToDate, settoDate] = useState(null);
  const [loadingDate, setLoadingDate] = useState(false);
  const [LeoforceSelectedClient, setLeoforceSelectedCleints] = useState([]);
  const tenantName = Cookies.get("tenant_name")
  const disabledFutureDates = (current) => {
    // Disable future dates by ensuring date is not after today
    return current && current > moment().endOf("day");
  };

  const handleFetchData = async () => {
    if (!fromDate || !toDate) {
      message.error("Please select both From Date and To Date");
      return;
    }


    // Check if the dates are the same

    if (fromDate.isSame(toDate, "day")) {
      message.error("From Date and To Date cannot be the same");
      return;
    }

    if (fromDate.isAfter(toDate)) {
      message.error("From Date cannot be after To Date");
      return;
    }

    const formattedFromDate = fromDate.format("MM-DD-YYYY");
    const formattedToDate = toDate.format("MM-DD-YYYY");

    const url = `${BaseUrl}Home/LeoforceAPIForCustomDates?vms=Leoforce&FromDate=${formattedFromDate}&ToDate=${formattedToDate}&uname=${UserName}`;

    setLoadingDate(true);

    try {
      const response = await axios.get(url, JsonConfig);

      if (response.status === 200) {
        const responseData = response.data;

        if (Array.isArray(responseData) && responseData.length > 0) {
          const { status, error } = responseData[0];

          if (status && status.toLowerCase().includes("error")) {
            message.error(`Status: ${status}`);
            return; // Stop execution if there is an error
          } else {
            message.success(`Status: ${status}`);
            setFromDate(null);
            setToDate(null);
          }

          if (error) {
            message.error(`Error: ${error}`);
            return; // Stop execution if there is an error
          }
        } else {
          message.success("Data fetched successfully");
          setFromDate(null);
          setToDate(null);
        }
        console.log("calling leoforce api");
        // Call the second API only after the first API succeeds
        await fetchLeoforceHrsData();
      } else {
        message.error("Failed to fetch data");
      }
    } catch (error) {
      message.error("Error fetching data");
    } finally {
      setLoadingDate(false);
    }
  };

  // Fetch Leoforce Hrs Data
  const fetchLeoforceHrsData = async () => {
    const userLogin = Cookies.get("UserLogin");
  
    if (!LeoforceSelectedClient || LeoforceSelectedClient.length === 0) {
      message.error("Please select at least one client.");
      return;
    }
  
    try {
      const url = `${BaseUrl}PReports_/LeoforceHrsdata`;
  
      const requestBody = {
        client: "Leoforce",
        username: userLogin,
        Clientname: LeoforceSelectedClient,  // ✅ Ensure it's an array
      };
  
      console.log("Sending request to:", url);
      console.log("Request body:", requestBody);
  
      const response = await axios.post(url, requestBody, StringConfig);
  
      if (response.data.statusCode === 500) {
        message.error("There is no LeoforceHrs Data");
      } else {
        message.success(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching LeoforceHrs data:", error.response?.data || error.message);
      message.error("Error fetching LeoforceHrs data");
    }
  };
  


  //Function to handle Leoforce multi client selection
  const handleLeoforceMultiClientSelect = (value) => {
    setLeoforceSelectedCleints(value);
  }

  console.log("selected", selectedClients);

  const handleChange = (value) => {
    setSelectedClient(value.value);
    console.log(value.value);
  };



  useEffect(() => {
    if (selectedClient) {
      fetchData(selectedClient);
    }
  }, [selectedClient]);

  const fetchData = async (client) => {
    setLoading(true);
    try {
      if (["leoforce"].includes(client)) {
        await handleSpecialClients(client);
      } else {
        const url = getClientUrl(client);
        await fetchClientData(url, client);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSpecialClients = async (client) => {
    try {
      const url = `${process.env.REACT_APP_BASE_URL}PReports_/GetClientsData`;

      const response = await axios.post(url, [client], JsonConfig);
      if (response.data.isSuccess) {
        setTableData(JSON.parse(response.data.payload) || []);
        // message.success(response.data.message);
      } else {
        message.info(
          response.data.message || "No data available for special client."
        );
      }
    } catch (error) {
      console.error("Error fetching special client data:", error);
    }

    const userLogin = Cookies.get("UserLogin");

    // First API call
    const params = { VMS: "Leoforce", frequency: "Weekly", userLogin };
    await axios.post(
      `${process.env.REACT_APP_BASE_URL}Home/DownloadForSelectedClients`,
      ["Leoforce"],
      { ...JsonConfig, params }
    );

    // Second API call
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}PReports_/LeoforceHrsdata`,
      { params: { client, username: userLogin }, ...StringConfig }
    );

    if (response.data.statusCode === 500) {
      message.error("There is no LeoforceHrs Data");
    } else {
      message.success(response.data.message);
    }

  };

  const getClientUrl = (client) => {
    switch (client) {
      case "Abbott":
      case "Integra":
      case "HPE":
        return `${process.env.REACT_APP_BASE_URL}PReports_/GetClientsData`;
      case "PR_Amgen":
        return `${process.env.REACT_APP_BASE_URL}PReports_/getAmgenClientData`;
      case "PR_BMS":
        return `${process.env.REACT_APP_BASE_URL}PReports_/getBMSClientData`;
      default:
        return "";
    }
  };

  const fetchClientData = async (url, client) => {
    const response = await axios.post(url, [client], JsonConfig);
    if (response.data.isSuccess) {
      setTableData(JSON.parse(response.data.payload) || []);
      message.success(response.data.message);
      // console.log(response.data.message)
    } else {
      message.info(response.data.message || "No data available.");
      // console.log(response.data.message)
    }
  };

  const columns = [
    {
      title: "Client ID",
      dataIndex: "Client_ID",
      key: "Client_ID",
      width: 140,
    },
    {
      title: "Worker ID",
      dataIndex: "Worker_ID",
      key: "Worker_ID",
      width: 140,
    },
    {
      title: "Last Name",
      dataIndex: "Last_Name",
      key: "Last_Name",
      width: 140,
    },
    {
      title: "First Name",
      dataIndex: "First_Name",
      key: "First_Name",
      width: 120,
    },
    { title: "W State", dataIndex: "W_State", key: "W_State", width: 90 },
    { title: "Shift", dataIndex: "Shift", key: "Shift", width: 90 },
    { title: "Client", dataIndex: "Client", key: "Client", width: 130 },
    { title: "FLSA", dataIndex: "FLSA", key: "FLSA", width: 110 },
    { title: "Payrate", dataIndex: "Payrate", key: "Payrate", width: 110 },
    { title: "Comment", dataIndex: "Comment", key: "Comment", width: 110 },
    {
      title: "Rate Override",
      dataIndex: "Rate_Override",
      key: "Rate_Override",
      width: 110,
    },
    { title: "Seq", dataIndex: "Seq", key: "Seq", width: 110 },
    { title: "RT Hours", dataIndex: "RT_Hours", key: "RT_Hours", width: 110 },
    { title: "OT Hours", dataIndex: "OT_Hours", key: "OT_Hours", width: 110 },
    { title: "DT Hours", dataIndex: "DT_Hours", key: "DT_Hours", width: 110 },
    {
      title: "Lunch Hours",
      dataIndex: "Lunch_Hours",
      key: "Lunch_Hours",
      width: 110,
    },
    {
      title: "Holiday Hours",
      dataIndex: "Holiday_Hours",
      key: "Holiday_Hours",
      width: 110,
    },
    {
      title: "Sick Hours",
      dataIndex: "Sick_Hours",
      key: "Sick_Hours",
      width: 110,
    },
    {
      title: "Vacation Hours",
      dataIndex: "Vacation_Hours",
      key: "Vacation_Hours",
      width: 110,
    },
    {
      title: "Salary Amount",
      dataIndex: "Salary_Amount",
      key: "Salary_Amount",
      width: 110,
    },
    {
      title: "Upload Date",
      dataIndex: "upload_Date",
      key: "upload_Date",
      width: 110,
    },
    {
      title: "Client Name",
      dataIndex: "ClientName",
      key: "ClientName",
      width: 140,
    },
  ];

  const renderSelectedClientComponent = () => {
    switch (selectedClient) {
      case "PR_Amgen":
        return <PRReports />;
      case "PR_BMS":
        return <PRReportBMS />;
      case "Abbott":
        return <PRReportAbbott client={selectedClient} />;
      case "Integra":
        return <PRReportIntegra client={selectedClient} />;
      case "HPE":
        return <PRHPE client={selectedClient} />;
      case "leoforce":
        return <PRReportSales client={selectedClient} />;

      default:
        return null;
    }
  };

  return (
    <Layout
      style={{
        backgroundColor: "white",
        height: "100vh",
        display: "flex",
        overflow: "hidden",
      }}
    >
      <SideNavBar />
      <Layout className="whole-div">
        <Header className="timecards-header">
          <Navbar />
        </Header>
        <Content style={{ overflowY: "scroll", overflowX: "hidden" }}>
        <div className="payrollhrs-allpages-class">
                        <Button className="payrollhrs-currentpage-button">Single Client Process</Button>
                        <Link to={`/${tenantName}/prreportsmulticlients`}><Button className="page-button">Multi Client Process</Button></Link>
                       
                      
                    </div>
       

          <div
            style={{
              display: "flex",
              justifyContent: "row",
              marginTop: "4%",
              marginLeft: "2%"
            }}
          >

            <Select
              labelInValue
              defaultValue={{ value: "Select", label: "Select Client" }}
              style={{ width: 170, height: 42, marginLeft: "100px" }}
              size="large"
              onChange={handleChange}
              options={[
                { value: "PR_Amgen", label: "PR_Amgen" },
                { value: "PR_BMS", label: "PR_BMS" },
                { value: "Abbott", label: "Abbott" },
                { value: "Integra", label: "Integra" },
                { value: "HPE", label: "HPE" },
                { value: "leoforce", label: "Leoforce" },
              ]}
            />
            <div style={{display:"flex",flexDirection:"row",width:"70%"}}>
              <DatePicker
                placeholder="Select From Date"
                value={fromDate}
                onChange={(date) => setFromDate(date)}
                format="MM-DD-YYYY"
                style={{ marginRight: 20, height: "38px", marginLeft: "50px" }}
                disabledDate={disabledFutureDates} // Disable future dates
              />
              <DatePicker
                placeholder="Select To Date"
                value={toDate}
                onChange={(date) => setToDate(date)}
                format="MM-DD-YYYY"
                style={{ marginRight: 20, height: "38px" }}
                disabledDate={disabledFutureDates} // Disable future dates
              />
              <Select
                mode="multiple"
                size="large"
                maxTagCount="responsive"
                allowClear
                style={{ marginBottom: "20px", width: "25%", marginLeft: "10px" ,marginRight:"30px"}}
                placeholder="Leoforce client selection"
                onChange={handleLeoforceMultiClientSelect}
                value={LeoforceSelectedClient}
                options={[
                  { value: "SPECTRAFORCE - US", label: "Spectraforce Technologies Inc." },
                  { value: "Iridex - US", label: "Iridex" },
                  { value: "Totalenergies Marketing Puerto Rico - PR", label: "TotalEnergies" },
                  { value: "OpenText", label: "OpenText" },
                  { value: "Lumen Technologies Service Group, LLC - US", label: "Lumen" },
                  { value: "Nucor", label: "Nucor" }
                ]}
              />
             <div >
             <Button
                type="primary"
               style={{height:"38px"}}
                onClick={handleFetchData}
                loading={loadingDate}
              >
                Download Timecards Leoforce
              </Button>
             </div>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ height: "43%" }}>
              {renderSelectedClientComponent()}
            </div>
            <div
              style={{
                height: "40%",
                margin: "70px",
                justifyContent: "flex-end",
              }}
            >
              {selectedClient && (
                <div>
                  <Table
                    columns={columns}
                    dataSource={tableData}
                    bordered
                    loading={loading}
                    pagination={{ pageSize: 50 }}
                    scroll={{ y: 400 }}
                  />
                </div>
              )}
            </div>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default PRReportsHomePage;
